module.exports = __webpack_public_path__ + "fonts/unicons.95c6a8be.woff";